import { render, staticRenderFns } from "./broadcast-message.vue?vue&type=template&id=a369fc1c&scoped=true&"
import script from "./broadcast-message.vue?vue&type=script&lang=js&"
export * from "./broadcast-message.vue?vue&type=script&lang=js&"
import style0 from "./broadcast-message.vue?vue&type=style&index=0&id=a369fc1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a369fc1c",
  null
  
)

export default component.exports